
function bookmark_status_close2(a)
{
  //  $("bookmark_status"+a).innerHTML = "";
   // document.getElementById('bookmark_status'+a).style.display='none';
}
function setCookie(name, value, expires, path, domain, secure)
{
    document.cookie = name + "=" + escape(value) +
       ((expires) ? "; expires=" + expires : "") +
             ((path) ? "; path=" + path : "") +
         ((domain) ? "; domain=" + domain : "") +
         ((secure) ? "; secure" : "");
}

function getCookie(name)
{
    var cookie = " " + document.cookie;
    var search = " " + name + "=";
    var setStr = null;
    var offset = 0;
    var end = 0;
    if (cookie.length > 0) {
        offset = cookie.indexOf(search);
        if (offset != -1) {
            offset += search.length;
            end = cookie.indexOf(";", offset)
            if (end == -1) {
                end = cookie.length;
            }
            setStr = unescape(cookie.substring(offset, end));
        }
    }
    return(setStr);
}

function bookmark_addedlist(json)
{
    var datadopstr=[];
    datadopstr=json.split("*");
   // bookmark_status_close2(datadopstr[1]);

    if (datadopstr[0] == 'ok') {
        
        document.getElementById('tofav'+datadopstr[1]).src='https://www.restate.ru/images/fav4f.png';

        var cnt = 0;
        cnt = $('#bmrkcnt').data('count');
        cnt = parseInt(cnt);
        cnt = cnt + 1;
        $('#bmrkcnt').data('count', cnt);
        $('#bmrkcnt').text(cnt);
        if (cnt > 0) { $('#bmrkcnt_a').show(); jQuery('#bmrkcnt_na').hide();}
        else { $('#bmrkcnt_a').hide(); jQuery('#bmrkcnt_na').show();}

    } else if (datadopstr[0] == 'error: duplicate') {
        
        document.getElementById('tofav'+datadopstr[1]).src='/images/fav4.png';

        var cnt = 0;
        cnt = jQuery('#bmrkcnt').data('count');
        cnt = parseInt(cnt);
        cnt = cnt - 1; if (cnt<0) cnt = 0;
        $('#bmrkcnt').data('count', cnt);
        $('#bmrkcnt').text(cnt);
        if (cnt>0) { jQuery('#bmrkcnt_a').show(); jQuery('#bmrkcnt_na').hide();}
        else { $('#bmrkcnt_a').hide(); jQuery('#bmrkcnt_na').show();}

    } else if (datadopstr[0] == 'error: unregistered') {
        
        bookmark_status_unregistered_notice2(datadopstr[1]);
    //    document.getElementById('bookmark_status').style.display='block';
        return;
    } else {
      //  $("bookmark_status"+datadopstr[1]).appendChild(Builder.node('p', 'Ошибка'));
      //  document.getElementById('bookmark_status').style.display='block';
    }
}
function bookmark_status_unregistered_notice2(a)
{   
   // bookmark_status_close2(a);
/*     $("bookmark_status"+a).appendChild(Builder.node(
            'div',
            {style:"padding-right:8px; float:right; padding-top:5px;"},
            [
                '',
         ///       Builder.node('a', {href: "", onClick: "event.stopPropagation(); bookmark_status_close2("+a+"); return false"}, [Builder.node('img', {src: "/images/close47.png", width: "8px"})])
            ]
        ));
    $("bookmark_status"+a).appendChild(Builder.node(
        'p',
        {style:"padding-right:8px; padding-left:8px; font-size:11px; text-align:left; padding-top:10px; margin-top:0px; color:#666;"},
        [
            'Чтобы сохранить ссылку ',
            Builder.node('a', {href: '/register/'}, 'зарегистрируйтесь '), 'или войдите через соц.сети '
        ]
    ));
        $("bookmark_status"+a).appendChild(Builder.node(
        'p',
        {style:"text-align:left; padding-left:8px; padding-top:0px; margin-top:0px;"},
        [
            
            Builder.node('a', {onclick: 'return RESTATE.Register.vkLogin(this)', style:'cursor:hand; cursor:pointer;'}, [Builder.node('img', {src: "/images/vk.png", width: "20px"})]),' ', Builder.node('a', {onclick: 'return RESTATE.Register.fbLogin(this)', style:'cursor:hand; cursor:pointer;'}, [Builder.node('img', {src: "/images/fb.png", width: "20px"})])
        ]
    )); */
  //  $("bookmark_status").appendChild(Builder.node('p', [
  //      Builder.node('a', {href: "", onClick: "bookmark_status_close(); return false"}, "[Закрыть]")
  //  ]));
  //document.getElementById('bookmark_status'+a).style.display='block';
  //  new Effect.Highlight('bookmark_status', {startcolor:'#ffff00', endcolor:'#ffffff'});
}
var RESTATE = {
    Register: {

        mergeSocnetToUser: function (e) {
            var block = $('.content-2');
            block.find('.preloader').show();
            block.find('.info').hide();
            var button = $(e);
            button.attr('disabled','disabled');
            var form = button.closest('.sublogin-form');
            var username = form.find('input[name=username]').val();
            var password = form.find('input[name=password]').val();

            $.post('/user/xhttpMergeSocnetToUser',{u: username, p: password}, function (json) {

                if (json.error){
                    if(json.error_message){
                        $('.content-2 .info').html(json.error_message).show();
                    }
                } else {
                    document.location = '/profile/';
                }
                button.removeAttr('disabled');
                $('.content-2 .preloader').hide();
            }, 'json');

            return false;
        },

        showSublogin: function (e) {
            var content = $(e).closest('.main');
            content.find('.content').hide();
            content.find('.content-2').show();
            return false;
        },

        showSubinfo : function (e) {
            var content = $(e).closest('.main');
            content.find('.content').hide();
            content.find('.content-3').show();
            return false;
        },

        onInitSocialPanel: function () {
            runOnKeys(function () {
                TINY.box.hide();
            }, [27]);
        },
        openRegister: function () {
            var template = $('.reg-templates .main-template').clone(true,true);
            var tmp = $('<div></div>').append(template);
            TINY.box.show(tmp.html());
            return false;
        },

        vkLogin: function (e) {

            document.location = '/login/vk/?referer=save';

            return false;

            /* VK.Auth.getLoginStatus(function (resp){
                alert(resp);
                if (!resp || !resp.session) {
                    alert('Tring to connect to VK account');
                    VK.Auth.login();
                } else {
                    alert('Logged in to VK');
                    console.log(resp.session);
                }
            });
            return false; */
        },

        fbLogin: function (e) {

            document.location = '/login/fb/?referer=save';

            return false;

            FB.getLoginStatus(function (response) {
                if (response.status == 'connected') {
                    console.log('User connected to facebook');
                    console.log('Fetching user information after login');
                    FB.api('/me', function (me) {
                        $.post('/user/xhttpRegisterWithFacebook', {data: me}, function (resp) {

                        }, 'json');
                    });
                } else {
                    console.log('User disconnected to facebook. Trying to connect to facebook account');
                    FB.login(function (auth) {
                        if (auth.authResponse) {
                            console.log('Fetching user information after login');
                            FB.api('/me', function (me) {
                                console.log(me);
                            });
                        }
                    }, {'scope' : 'email'});
                }
            });

            return false;
        }
    }
  }